module.exports = __webpack_public_path__ + "img/icon_references.6bf6c86a.png";